module.exports = __webpack_public_path__ + "gl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gl.svg
// module id = 570
// module chunks = 0